// src/components/icons/User.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

function UserPage() {
  const navigate = useNavigate();

  const icons = [
    { label: 'UserDetails', path: '/user/details', emoji: '👤' },
    { label: 'Role', path: '/user/role', emoji: '🔑' },
  ];

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>User Management</h2>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: '30px' }}>
        {icons.map((icon) => (
          <div
            key={icon.label}
            onClick={() => navigate(icon.path)}
            style={{
              width: '120px',
              height: '120px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: '2rem' }}>{icon.emoji}</span>
            <p>{icon.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserPage;
